import { tv } from 'tailwind-variants';

export const sidebarStyles = tv({
  slots: {
    container: `
      flex flex-col h-full transition-colors duration-300 ease-in-out
    `,
    header: `
      flex items-center justify-center p-6
    `,
    logo: `
      h-9
    `,
    nav: `
       overflow-y-auto flex-1
    `,
    list: `
      flex flex-col gap-0.5 px-1.5 py-2
    `,
    link: `
      flex items-center w-full px-4 py-3 text-left
      rounded-xl transition-colors duration-150 ease-in-out
      focus:outline-none
    `,
    userContainer: 'm-4',
  },
  variants: {
    collapsed: {
      true: {
        container: 'w-18',
        header: 'p-4',
        logo: 'hidden',
        list: 'p-2',
        link: 'justify-center px-2',
      },
      false: {
        container: 'w-64',
      },
    },
    variant: {
      default: {
        container: '',
        link: '',
      },
      compact: {
        container: '',
        header: 'p-4',
        list: 'p-2',
        link: 'px-3 py-2 text-sm',
      },
    },
  },
  compoundVariants: [
    {
      collapsed: true,
      class: {
        link: 'tooltip tooltip-right',
      },
    },
  ],
  defaultVariants: {
    collapsed: false,
    variant: 'default',
  },
});

export const sidebarSectionStyles = tv({
  slots: {
    header:
      'flex cursor-pointer items-center justify-between rounded-xl px-4 py-2 mt-3 mb-1 transition-colors duration-150 hover:bg-hover',
    label: 'text-xs font-semibold uppercase tracking-wider text-fg-muted',
    toggle: 'text-fg-muted transition-transform duration-150',
  },
  variants: {
    sidebarCollapsed: {
      true: {
        header: 'hidden',
      },
      false: {},
    },
    expanded: {
      true: {
        toggle: 'rotate-0',
      },
      false: {
        toggle: '-rotate-90',
      },
    },
  },
  defaultVariants: {
    sidebarCollapsed: false,
    expanded: true,
  },
});

export const sidebarLinkStyles = tv({
  slots: {
    link: `
      flex items-center w-full px-4 text-left h-10
      rounded-xl transition-colors duration-150 ease-in-out
    `,
    icon: `
      shrink w-5 mr-3 text-lg
    `,
    text: `
      font-medium
    `,
  },
  variants: {
    active: {
      true: {
        link: 'bg-active text-fg hover:bg-hover active:bg-active',
        icon: 'text-fg',
      },
      false: {
        link: 'hover:bg-hover active:bg-active text-fg-muted',
        icon: 'text-fg-muted',
      },
    },
    collapsed: {
      true: {
        link: 'justify-center px-2',
        icon: 'mr-0',
        text: 'hidden',
      },
      false: {},
    },
    variant: {
      default: {},
      compact: {
        link: 'px-3 py-2 text-sm',
      },
    },
    size: {
      sm: {
        link: 'h-9 text-sm',
        icon: 'text-base',
      },
      md: {
        link: 'h-10',
        icon: 'text-lg',
      },
      lg: {
        link: 'h-13 text-lg',
        icon: 'text-xl',
      },
    },
  },
  defaultVariants: {
    active: false,
    collapsed: false,
    variant: 'default',
    size: 'md',
  },
});
